// const __request_contentType_json = require(`frontend/app/src/lib/data-service/yinzhilv-temporary-storage-system/__request/__yinzhilv_request_contentType_json`);
const __request = require('../__request/__yinzhilv_request_contentType_json')
//import __request from './__yinzhilv_request_contentType_json'
const r = function (pParameter) {
  if (!pParameter) pParameter = {};
  pParameter.appKey = `yinzhilv-temporary-storage-system`;
  return __request(pParameter);
};
module.exports = r;
